import { Avatar, Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import { LuCopy } from 'react-icons/lu';
import { IJob } from 'wisestep-api';
import { WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import CardWrapper from '../../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';
import { copyStringToClipboard } from '../../../../features/candidateLayout/components/childComponets/CandidateDetailsCard/Helper';
import AI_Image from '../../../../images/AI.svg';
import { success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import useGetSocialSearchBooleanString from '../../hooks/useGetSocialSearchBooleanString';
import {
  handleSharingOfJobsAcrossPlatforms,
  socialSearchOptions,
} from '../../utils/SocialSearchHelper';

import SocialSearchCard from './SocialSearchCard';

const SocialSearch = ({ job }: { job: IJob }) => {
  const { socialSearchBooleanString } = useGetSocialSearchBooleanString(job);

  const setNotification = useNotificationStore((state) => state.setNotification);

  const handleCopy = () => {
    copyStringToClipboard(socialSearchBooleanString);
    setNotification(success('Copied Successfully !!'));
  };

  const handleOptionClick = (label: string) => () =>
    handleSharingOfJobsAcrossPlatforms(label, job, socialSearchBooleanString);

  return (
    <CardWrapper sx={{ pt: 0 }}>
      <Grid display="flex" flexDirection="column" rowGap={2}>
        <Grid xs={12}>
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            Social Search
          </WsTypography>
        </Grid>
        <Grid xs={12} container alignItems="center" gap={1}>
          <Avatar src={AI_Image} variant="square" sx={{ width: 30, height: 30 }} />
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Boolean</WsTypography>
          <Grid xs={7}>
            <TextField
              value={socialSearchBooleanString}
              fullWidth
              disabled
              multiline
              maxRows={6}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton aria-label="copy text" onClick={handleCopy}>
                      <LuCopy size={18} color={WsColors.TheBlues600} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              inputProps={{
                style: {
                  padding: 0,
                  fontSize: 14,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                },
              }}
            />
          </Grid>
        </Grid>
        <Grid display="flex" alignItems="center" gap={1} flexWrap="wrap">
          {socialSearchOptions.map((option, index) => (
            <Grid
              item
              xs={2.9}
              key={index}
              sx={{ cursor: 'pointer' }}
              onClick={handleOptionClick(option.label)}
            >
              <SocialSearchCard label={option.label} image={option.image} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </CardWrapper>
  );
};

export default SocialSearch;
